export const fileContainer = {position: 'relative'}

export const thumbnail = {
    border: '1px solid #DCE3EB',
    borderRadius: '$messageSpeechBubbleDefault',
    borderTopLeftRadius: '$messageSpeechBubbleDefaultCorner',
    compoundVariants: [
        {
            css: {borderTopRightRadius: '$messageSpeechBubbleDefault'},
            me: true,
            repeated: true,
        },
    ],
    minHeight: 40,
    minWidth: 80,
    overflow: 'hidden',
    position: 'relative',
    variants: {
        me: {
            true: {
                border: '1px solid #DCE3EB',
                borderTopLeftRadius: '$messageSpeechBubbleDefault',
                borderTopRightRadius: '$messageSpeechBubbleDefaultCorner',
                marginLeft: 10,
                marginRight: 0,
            },
        },
        repeated: {true: {borderTopLeftRadius: '$messageSpeechBubbleDefault'}},
        size: {
            small: {
                maxHeight: 150,
                maxWidth: 150,
            },
        },
    },
}

export const thumbnailOverlay = {
    '& span': {
        '&:hover': {color: 'inherit'},
        'color': 'inherit',
        'fontSize': 11,
        'textDecoration': 'underline',
        'textOverflow': 'ellipsis',
        'whiteSpace': 'nowrap',
    },
    '& time': {
        fontSize: 12,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    'alignItems': 'flex-end',
    'backgroundColor': '#00000080',
    'borderRadius': 6,
    'bottom': 4,
    'color': '#B2C2D5',
    'display': 'flex',
    'flexDirection': 'column',
    'maxWidth': 'calc(100% - 8px)',
    'overflow': 'hidden',
    'padding': '2px',
    'position': 'absolute',
    'right': 4,
    'zIndex': '$fileThumbnailOverlay',
}


export const fileSpeechBubble = {
    paddingBottom: 10,
    paddingLeft: 10,
    paddingRight: 14,
    paddingTop: 10,
}

export const fileDocument = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
}

export const icon = {
    display: 'flex',
    marginRight: 6,
    width: 32,
}

export const info = {
    display: 'flex',
    flexDirection: 'column',
}

export const details = {
    alignItems: 'center',
    display: 'flex',
}

export const fileSize = {
    color: '#7E95AF',
    fontSize: 13,
    marginRight: 'auto',
}

export const fileMessageTime = {fontSize: 13}
